fx.ns("desktop.common.preview", class PreviewArea extends shared.stage.BookArea {

    constructor(page, model, parentContainer, side)
	{
        super(page, model, parentContainer, side);
    }

   
    load()
    {
        super.load();

        
        
    }

    get areaWidth()
    {
        if (this.displayedSide == "right")
            return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2;
        if (this.displayedSide == "left")
            return this.page.isCover ? this.book.pageWidth : this.book.pageWidth * 2;
        
        return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
    }

    get stageContainerWidth()
    {
        if (this.displayedSide == "right")
            return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2;
        if (this.displayedSide == "left")
            return this.page.isCover ? this.book.pageWidth +  this.book.sliceWidth: this.book.pageWidth * 2;
        
        return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
    }

    get stageWidth()
    {
        if (this.displayedSide == "right")
            return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
        if (this.displayedSide == "left")
            return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;

        return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
    }

});